<template>

    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Import CSV" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <p class="text-subtitle-2 mb-4">Importing records {{ importType ? "of type " + importType : "" }} to vehicle
                {{
                    vehicle.name }} on
                mission {{ mission.name }}
            </p>
            <v-form ref="csvForm">
                <v-file-input accept="text/csv" :rules="rulesCSV" v-model="file" label="File input"></v-file-input>
                <v-label v-if="percentCompleted != '0%' && percentCompleted != '100%'">{{ "Loading file is " +
                    percentCompleted
                }}</v-label>
                <v-radio-group v-model="importType" :rules="[v => !!v || 'You must select an import type']">
                    <v-radio color="primary" label="LOG" value="log" />
                    <v-radio color="primary" label="LIVE" value="live" />
                </v-radio-group>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="uploadCSV()" class="w-100" color="primary" variant="elevated" text="Import CSV"></v-btn>
        </v-card-actions>
    </v-card>

</template>


<script setup lang="js">
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { api_url } from '@/config/api_url';
import { useNotificationStore } from '@/store/notificationStore';
import axios from 'axios';
import { ref, warn } from 'vue';
const rulesCSV = [
    value => {
        if (!value) {
            return 'CSV file is required';
        }
        return true;
    }]
const loading = ref(false);
const emit = defineEmits(['close']);
const props = defineProps({
    mission: Object,
    vehicle: Object
})
const csvForm = ref();
const importType = ref();
const file = ref();
const notificationStore = useNotificationStore();

const uploadCSV = async () => {
    loading.value = true;
    const isValid = await csvForm.value?.validate();
    if (isValid.valid) {

        const selectedFile = file.value;
        if (!selectedFile.name.match(/\.csv$/i)) {
            notificationStore.setNotification('Incorrect extension', 'The file must be a .csv', 'mdi-alert', 'error');
            loading.value = false;
            return;
        }

        sendCSV(selectedFile);
        if (file.value.size > 100000) {
            notificationStore.setNotification('Very large file', 'It will take some time for the file to be added', 'mdi-warning', 'warn');

        } else {
            notificationStore.setNotification('Uploading file', 'The file is being processed, it will be finished shortly', 'mdi-warning', 'warn');
        }

    } else {
        loading.value = false;
    }
}

const percentCompleted = ref('0%');


const sendCSV = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mission_id', props.mission.id);
    formData.append('vehicle_id', props.vehicle.id);
    formData.append('import_type', importType.value);
    await axios.post(`${api_url}/admin/mission/uploadCSV`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
            percentCompleted.value = Math.round((progressEvent.loaded * 100) / progressEvent.total) + "%";
        }
    }).then((res) => {
        notificationStore.setNotification('Uploaded csv', res.data.message, 'mdi-alert', 'success');
    }).catch(res => {
        notificationStore.setNotification('Error', res.response.data.error, 'mdi-alert', 'error');
    }).finally(e => {
        emit('close');
    });

}

</script>